import type { ReactNode } from "react";
import { GitMerge, Hash } from "lucide-react";
import { StepInfoRow } from "../../StepInfoRow";
import { getString } from "../helpers";
import type { SummaryTranslator } from "../types";

export function getAgentDecisionSummary(config: Record<string, unknown>, t: SummaryTranslator): ReactNode[] {
  const items: ReactNode[] = [];

  const modelId = getString(config.model_id);
  const modelDisplay = getString(config.model_display);
  const prompt = getString(config.prompt);
  const branches = Array.isArray(config.branches)
    ? (config.branches as Array<Record<string, string>>)
    : [];

  if (modelId) {
    items.push(
      <StepInfoRow
        key="model"
        icon={<GitMerge className="size-3.5" />}
        label={t("summaries.agent_decision.label_model")}
        value={modelDisplay || t("summaries.shared.unknown_reference")}
      />
    );
  }

  if (prompt) {
    const preview = prompt.length > 70 ? prompt.slice(0, 70) + "…" : prompt;
    items.push(
      <StepInfoRow
        key="prompt"
        icon={<Hash className="size-3.5" />}
        label={t("summaries.agent_decision.label_prompt")}
        value={preview}
      />
    );
  }

  if (branches.length > 0) {
    const labels = branches.map((b) => b.label).filter(Boolean).join(" / ");
    items.push(
      <StepInfoRow
        key="branches"
        icon={<GitMerge className="size-3.5" />}
        label={t("summaries.agent_decision.label_branches")}
        value={labels || t("summaries.agent_decision.branches_count", { count: branches.length })}
      />
    );

    // Show first 2 branch targets
    branches.slice(0, 2).forEach((b, i) => {
      if (b.target_alias) {
        items.push(
          <StepInfoRow
            key={`branch-${i}`}
            icon={<Hash className="size-3.5" />}
            label={b.label || `Branch ${i + 1}`}
            value={`→ ${b.target_alias}`}
            mono
          />
        );
      }
    });
  }

  return items;
}
